// Which renderer draws a cell, and the classes its td carries.

import React, { useContext } from 'react'
import PropTypes from 'prop-types'

import { TableContext } from '../context'
import { displayText } from '../format'
import { ClippedValue } from '../tooltip/Tooltip'
import { BadgeCell } from './BadgeCell'
import {
  ActionsCell,
  ButtonCell,
  LinkCell,
  SplitCell,
} from './InteractiveCells'

export const cellClass = column =>
  [
    column.type === 'numeric' && 'me-table-numeric',
    column.type === 'actions' && 'me-table-actions',
    column.wrap === 'nowrap' && 'me-table-nowrap',
    column.wrap === 'ellipsis' && 'me-table-ellipsis',
    column.className,
  ]
    .filter(Boolean)
    .join(' ') || undefined

const RENDERERS = {
  link: LinkCell,
  button: ButtonCell,
  split: SplitCell,
  actions: ActionsCell,
}

export const renderCell = (column, row, density) => {
  if (column.render) return column.render(row)
  if (column.type === 'badge') return <BadgeCell badge={row[column.key]} />
  const Renderer = RENDERERS[column.type]
  if (Renderer) return <Renderer column={column} row={row} />
  const text = displayText(column, row)
  // an ellipsis cell clips, and so does every text cell in Compact density, whatever its wrap policy; a
  // clipped value discloses its complete value
  return (column.wrap === 'ellipsis' || density === 'compact') && text ? (
    <ClippedValue text={text} />
  ) : (
    text
  )
}

export const Cell = ({ column, row }) => {
  // read without useTable, so a cell also renders outside a table
  const table = useContext(TableContext)
  const density = table?.state?.view?.density
  return <>{renderCell(column, row, density)}</>
}
Cell.propTypes = {
  column: PropTypes.object.isRequired,
  row: PropTypes.object.isRequired,
}
